import { commonClient, httpClient } from 'src/libraries/http.library';
import {
    EmployeeSearchPayloadSchema,
    EmployeeUsersPayloadSchema,
    IEmployeeSearchForm,
    EmployeeSearchInternalPayloadSchema,
    EmployeeDetailsSchema,
} from 'src/models/employee.model';

const client = httpClient();
const common = commonClient();

const services = {
    usersPOST: async (params: IEmployeeSearchForm) => {
        const defaultList: IEmployeeSearchForm = {
            eMailIds: [],
            employeeNos: [],
            firstNames: [],
        };

        return common.post(
            '/employees',
            {
                ...defaultList,
                ...params,
            },
            EmployeeUsersPayloadSchema
        );
    },

    searchGET: async (name: string) => {
        return common.get(
            'employeesByName',
            { name },
            EmployeeSearchPayloadSchema
        );
    },

    searchInternalGET: async (name: string) => {
        return client.get(
            'employees',
            {
                name,
            },
            EmployeeSearchInternalPayloadSchema
        );
    },

    userGET: async (emp_no: string) => {
        return common.get(
            `employee?emp_no=${emp_no}`,
            null,
            EmployeeDetailsSchema
        );
    },
};

export default services;
